import { render, staticRenderFns } from "./legend-item.vue?vue&type=template&id=51a81ade"
import script from "./legend-item.ts?vue&type=script&lang=ts&external"
export * from "./legend-item.ts?vue&type=script&lang=ts&external"
import style0 from "./legend-item.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a81ade')) {
      api.createRecord('51a81ade', component.options)
    } else {
      api.reload('51a81ade', component.options)
    }
    module.hot.accept("./legend-item.vue?vue&type=template&id=51a81ade", function () {
      api.rerender('51a81ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overview/legend-item/legend-item.vue"
export default component.exports